module.exports = __webpack_public_path__ + "static/media/bg_page50.af5fa414.png";